
// Vue
import Vue from 'vue';

// element
import 'element-ui';

// icon
import "./assets/font/iconfont.css";

// bus
import { bus } from "./utils/bus";
Vue.prototype.$bus = bus;

// component registry
import install from '../packages/index.js';
install(Vue);


// scan file
import scan from './utils/scan_file';
Vue.use( scan );

export default { install};



// WEBPACK FOOTER //
// ./src/npm.js